export enum ApplicationRegistrationTenantType {
    None = "None",
    Any = "Any",
    Chevron = "Chevron",
    NonChevron = "NonChevron"
}